<template>
    <div>
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Assign Brunch Fees Payment</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row justify="center">
                    <!-- <v-col cols="11">
                        <v-combobox v-model="selected_children" :items="children" label="Select Child" item-text="name" outlined dense prepend-icon="mdi-account-child-circle" @change="getDetails()"></v-combobox>
                    </v-col> -->
                    <v-col sm="4">
                    <v-icon color="error">*</v-icon>
                    <v-text-field outlined rounded color="#0F2027" dense placeholder="Enter PRN No." v-model="grno_or_app_form_no" type="text" hint="For example :: 121/111"></v-text-field>
                </v-col>
                <v-col sm="2">
                    <v-btn :disabled="!grno_or_app_form_no" class="mt-6 button" @click="getDetails()" :loading="proceed_btn_load">Proceed</v-btn>
                </v-col>
                </v-row>

                <!-- <v-row justify="end" dense>
          <v-col cols="6">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              placeholder="Search by title / decription"
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="1"> </v-col>
        </v-row> -->
            </v-card-text>
        </v-card>
        <br />

        <!-- <div v-for="notice in searchByTitleOrDescription" :key="notice.id"> -->

        <v-card dense v-if="show == true" class="box">
            <center>Academic Year : {{ current_ay }}</center>

            <v-card v-if="already_selected_component_selection_list.length != 0">
                <v-toolbar dense class="toolbar" flat color="white">
                    <v-toolbar-title>Already selected brunch fees</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-data-table :headers="already_selected_headers" :items="already_selected_component_selection_list" class="elevation-1 mytable" dense :search="search"> </v-data-table>
                </v-card-text>
            </v-card><br>
            <v-card>
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Select new brunch fees</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
           
            <v-card-text>
            <v-data-table :headers="headers" :items="get_component_installmet_list" class="elevation-1 mytable" dense :search="search">
                <template v-slot:item.action="{ item }">
                    <div>
                        <!-- <v-checkbox v-model="selected_install" dense color="success"></v-checkbox> -->
                        <v-checkbox multiple class="mr-5" dense v-model="selected_install" :value="item.fees_component_id"></v-checkbox>
                    </div>
                </template>
            </v-data-table>
            </v-card-text>
            </v-card>
            <br />
            <v-row justify="center" v-if="get_component_installmet_list.length != 0">
                <v-btn @click="putEntry()" class="button"> Apply </v-btn>
            </v-row>
        </v-card>
        <br />
    </div>
    <!--{{ child_notice }}-->
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    export default {
        data: () => ({
            child_info: null,
            children: [],
            selected_install: [],
            get_component_installmet_list: [],
            already_selected_component_selection_list: [],
            grno_or_app_form_no: null,
            headers: [
                {
                    text: "Fees Component",
                    align: "left",
                    sortable: false,
                    value: "fees_component_name",
                },
                {
                    text: "Fees Installment",
                    align: "left",
                    sortable: true,
                    value: "fees_installment_name",
                },
                {
                    text: "Due Date",
                    align: "left",
                    sortable: true,
                    value: "due_date",
                },
                {
                    text: "Fees Ammount",
                    align: "left",
                    sortable: true,
                    value: "total_fees_amount",
                },
                { text: "Actions", value: "action", sortable: false },
            ],

            already_selected_headers: [
                {
                    text: "Fees Component",
                    align: "left",
                    sortable: false,
                    value: "fees_component_name",
                },
                {
                    text: "Fees Installment",
                    align: "left",
                    sortable: true,
                    value: "fees_installment_name",
                },
                {
                    text: "Due Date",
                    align: "left",
                    sortable: true,
                    value: "due_date",
                },
                {
                    text: "Fees Ammount",
                    align: "left",
                    sortable: true,
                    value: "total_fees_amount",
                },
                // { text: "Actions", value: "action", sortable: false },
            ],

            show: false,
            selected_children: "",
            child_notice: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            loader: true,
            current_ay: "",
            search: "",
            s3url: "",
        }),

        methods: {
            getDetails() {
                // alert("in getDetails");
                // alert(this.selected_children.id);
                const formData = {
                    child: this.grno_or_app_form_no,
                };
                axios
                    .post("/AccountingAndFees/getDetails", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.status == "Fail") {
                                this.showSnackbar("#b71c1c", res.data.status_reason);
                                this.show = false
                                return false
                            }
                            if (res.data.flag == "YES") {
                                this.get_component_installmet_list = res.data.get_component_installmet_list;
                                this.already_selected_component_selection_list = res.data.already_selected_component_selection_list;
                                this.current_ay = res.data.current_ay;
                                this.show = true;
                            } else if (res.data.flag == "NO") {
                                this.showSnackbar("#b71c1c", res.data.snackbar);
                            }
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },

            putEntry() {
                // alert('Put entry')
                // alert('slected' +this.selected_install)
                const formData = {
                    selected_installments: this.selected_install,
                    child: this.grno_or_app_form_no,
                };
                axios
                    .post("/AccountingAndFees/putComponentSelection", formData)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            if (res.data.status.code == "SUCCESS") {
                                this.showSnackbar("#4caf50", "Learner Fees Component selection added succesfully....");
                                this.selected_install = [];
                                this.getDetails();
                            }
                            // this.get_component_installmet_list =
                            //   res.data.get_component_installmet_list;
                            //   this.current_ay = res.data.current_ay
                            // this.show = true;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },

        mounted() {
            //alert("this.s3url::"+this.s3url)
            axios
                .post("/AccountingAndFees/getChildList")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if ((res.data.status = "SUCCESS")) {
                            this.children = res.data.learners;
                        } else {
                            alert(res.data.status_reason);
                        }
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.loader = false;
                    //alert("done")
                });
        },
        computed: {
            searchByTitleOrDescription() {
                /*function compare(a, b) {
        if (a.title < b.title || a.description < b.description) return -1;
        if (a.title > b.title || a.description < b.description) return 1;
        return 0;
      }
      if (!this.search) return this.child_notice.notices.sort(compare);*/

                return this.child_notice.notices.filter((tbdata) => {
                    return tbdata.title.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 || tbdata.description.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
                });
            },
        }, // end of computed()
    };
</script>

<style scoped>
    .even {
        background-color: whitesmoke;
    }
    .odd {
        background-color: white;
    }
    .mytable /deep/ thead th {
        background: #0f2027; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
